import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { FC } from 'react'
import { FeatureTableEntry } from './FeatureTableEntry'
import { SopFeatureRow } from './utils'

interface FeatureTableProps {
  features: SopFeatureRow[]
}

export const FeatureTable: FC<FeatureTableProps> = ({ features }) => {
  return (
    <Paper data-testid="feature-table">
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Enabled</TableCell>
              <TableCell>Consented By</TableCell>
              <TableCell>Consent Timestamp</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {features.map(feature => (
              <FeatureTableEntry key={`${feature.name}-${feature.consent?.acceptedAt ?? 'no-consent'}`} feature={feature} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}
